import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemePreferences } from '@socialgoodsoftware/theme';
import { ApiProvider } from './lib/api-client';
import { App } from './App';

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <ApiProvider>
        <ThemePreferences>
          <App />
        </ThemePreferences>
      </ApiProvider>
    </StrictMode>
  );
}
